import { get } from '../api/request';

import axios from 'axios';

// 获取token
export async function uploadPic(file, bucket) {
  const token = localStorage.getItem('blog-userinfo-token') || '';

  const url = `/api/file/upload`;
  var formdata = new FormData();
  formdata.append('file', file);
  formdata.append('bucket', bucket);

  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url,
      data: formdata,
      headers: {
        Authorization: `Bearer ${token}`,
        'content-type': 'multipart/form-data',
      },
    })
      .then((res) => {
        console.info('uploadPic--success', res);
        resolve(res.data);
      })
      .catch((err) => {
        console.info('uploadPic--err', err);
        reject(err);
      });
  });
}

// 图片列表
export async function getImgList(params) {
  const url = `/api/file/list`;
  const result = await get(url, params);
  return result.data;
}
